let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1lDno")).then(() => parcelRequire('1Jx70'));